module.exports = __webpack_public_path__ + "img/pic7.2b800414.png";